import React, { useCallback } from "react";

import {
    useAddConditionButton,
    useRuleConditionSelector,
} from "../ConditionBuilder/utils";
import { useModalState } from "@cayuse/shared-react.hooks.use-modal-state";
import { useRuleBuilderContext } from "../../context/useRuleBuilderContext";

const ConditionButton = ({ operand, disabled }) => {
    const { isOpen: isModalOpen, openModal, closeModal } = useModalState(false);
    const { addRule, addCondition, getNewRuleIndex, setEditingOperand } =
        useRuleBuilderContext();
    const addConditionButton = useAddConditionButton({
        onClick: openModal,
        disabled,
    });

    const handleUpdate = useCallback(
        (updatedValues) => {
            if (operand) {
                addCondition({ operand, ...updatedValues });
                setEditingOperand(false);
            } else {
                addRule({ ...updatedValues });
            }

            closeModal();
        },
        [closeModal, addRule, getNewRuleIndex]
    );

    const ruleConditionSelectorModal = useRuleConditionSelector({
        open: isModalOpen,
        onCancel: closeModal,
        onClose: closeModal,
        onUpdate: handleUpdate,
        rule: {},
    });

    return (
        <>
            {addConditionButton}
            {ruleConditionSelectorModal}
        </>
    );
};

export default ConditionButton;
